import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import 'datatables.net'

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss']
})
export class QuestionsComponent implements OnInit {
    tableWidget: any;

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
      this.initDatatable()
  }

  private initDatatable(): void {
      let exampleId: any = $('#table');
      this.tableWidget = exampleId.DataTable({
          select: true,
          pageLength: 25,
          dom: 'Bfrtip',
      });
      $('.dataTables_length, .dataTables_filter').hide();
      $('.next').css('float', 'right');
  }

}
